<template>
  <b-modal
    :visible="showModalCalendario"
    :size="$store.getters['app/currentBreakPoint'] !== 'xl' ? 'lg' : $store.getters['app/currentBreakPoint']"
    title="Gestión de calendario"
    body-class="m-2"
    ok-only
    hide-footer
    @change="(val) => $emit('update:show-modal-calendario', val)"
  >
    <div>
      <b-row>
        <b-col
          cols="12"
          lg="5"
          md="12"
        >
          <!-- Eventos obligatorios -->
          <div class="d-flex align-items-end mb-75">
            <feather-icon
              size="24"
              class="mr-1"
              icon="CheckCircleIcon"
            />
            <b-card-title class="m-0">
              Eventos mínimos obligatorios
            </b-card-title>
          </div>
          <scheadule-minimum
            :loading-types="loaderTypes"
            :tipos="tipos || []"
            :calendario="calendario"
          />

          <!-- Form de eventos -->
          <div class="d-flex align-items-end mb-75 mt-2">
            <feather-icon
              size="24"
              class="mr-1"
              icon="ToolIcon"
            />
            <b-card-title class="m-0">
              Información del evento
            </b-card-title>
          </div>

          <scheadule-form
            :periodo="periodo"
            :to-edit="itemSelected"
            @fill-types="tipos = $event"
            @loading-types="loaderTypes = $event"
            @reload-data="getCalendario(periodo); $emit('reload-data')"
          />
        </b-col>

        <b-col
          cols="12"
          lg="7"
          md="12"
        >
          <!-- Lista de eventos cargados -->
          <div class="d-flex align-items-end mb-75">
            <feather-icon
              size="24"
              class="mr-1"
              icon="ListIcon"
            />
            <b-card-title class="m-0">
              Eventos guardados
            </b-card-title>
          </div>
          <div class="business-card mb-75">
            <scheadule-list
              ref="scheaduleListRef"
              :loader="loader"
              :calendario="calendario"
              @selected-item="itemSelected = $event;"
              @set-loader="loader = $event"
              @reload-data="getCalendario(periodo); $emit('reload-data');"
            />
          </div>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import {
  ref, watch,
} from '@vue/composition-api'
import {
  BModal,
  BRow,
  BCol,
  BCardTitle,
  VBTooltip,
  VBToggle,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ScheaduleList from './components/ScheaduleList.vue'
import ScheaduleForm from './components/ScheaduleForm.vue'
import ScheaduleMinimum from './components/ScheaduleMinimum.vue'
import { getScheadule } from '../usePeriodos'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BCardTitle,

    ScheaduleList,
    ScheaduleForm,
    ScheaduleMinimum,
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-toggle': VBToggle,
    Ripple,
  },
  model: {
    prop: 'showModalCalendario',
    event: 'update:show-modal-calendario',
  },
  props: {
    showModalCalendario: {
      type: Boolean,
      required: true,
    },
    periodo: {
      type: [Number, null],
      default: null,
    },
  },
  setup(props) {
    const toast = useToast()
    const loader = ref(false)
    const loaderTypes = ref(false)
    const itemSelected = ref({}) //* Tipo seleccionado
    const calendario = ref([])
    const tipos = ref([])
    const scheaduleListRef = ref(null)

    const getCalendario = periodo => {
      if (scheaduleListRef.value) scheaduleListRef.value.tipoSelected = {}
      loader.value = true
      getScheadule(periodo).then(response => {
        loader.value = false
        calendario.value = response.data
      }, error => {
        calendario.value = []
        loader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Calendario de periodo',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 10000 })
      })
    }

    watch(() => props.showModalCalendario, showModal => {
      if (showModal && props.periodo && props.periodo !== null) itemSelected.value = {}; getCalendario(props.periodo)
    })

    return {
      // Data
      calendario,
      itemSelected,
      tipos,

      // Refs
      scheaduleListRef,

      // Methods
      getCalendario,

      // Loader
      loader,
      loaderTypes,
    }
  },
}
</script>
